// src/services/fileService.ts
import { ServiceFile } from "../interfaces/services/File";
import apiUrls from "../store/apiUrls";
import {
  getCdnUrlFromPresignedResult,
  PresignedResult,
} from "../utils/s3ToCdn";
import apiService from "./apiService";

const fileService = {
  /** Announcement için presigned URL ve code alır */
  announcement: (fileName: string): Promise<ServiceFile[] | ServiceFile> =>
    apiService.FILE.get(`${apiUrls.file.file.announcement}/${fileName}`),

  /** Content için presigned URL ve code alır */
  content: (fileName: string): Promise<ServiceFile[] | ServiceFile> =>
    apiService.FILE.get(`${apiUrls.file.file.content}/${fileName}`),

  /** Profile photo için presigned URL ve code alır */
  profilePhoto: (fileName: string): Promise<ServiceFile[] | ServiceFile> =>
    apiService.FILE.get(`${apiUrls.file.file.profilePhoto}/${fileName}`),

  /**
   * Generic upload helper: presignedResult almak, PUT ile yüklemek ve CDN URL döndürmek
   */
  uploadFile: async (
    presignedGetter: (fileName: string) => Promise<ServiceFile[] | ServiceFile>,
    file: File
  ): Promise<string> => {
    const fileName = file.name || `file_${Date.now()}`;
    const fileType = file.type || "application/octet-stream";

    // 1) Presigned sonuç al
    const presignedData = await presignedGetter(fileName);
    const presignedArray = Array.isArray(presignedData)
      ? presignedData
      : [presignedData];
    if (presignedArray.length === 0) {
      throw new Error("Presigned URL alınamadı");
    }
    const presignedResult: PresignedResult = {
      url: presignedArray[0].url,
      code: presignedArray[0].code,
    };

    // 2) PUT ile yükle
    const res = await fetch(presignedResult.url as string, {
      method: "PUT",
      headers: { "Content-Type": fileType },
      body: file,
    });
    if (!res.ok) {
      const text = await res.text();
      throw new Error(`Upload failed: ${res.status} ${text}`);
    }

    // 3) CDN URL oluştur
    const cdnUrl = getCdnUrlFromPresignedResult(presignedResult);
    if (!cdnUrl) {
      throw new Error("CDN URL oluşturulamadı");
    }
    return cdnUrl;
  },

  /** Content için upload */
  uploadContent: (file: File): Promise<string> =>
    fileService.uploadFile(fileService.content, file),

  /** Announcement için upload */
  uploadAnnouncement: (file: File): Promise<string> =>
    fileService.uploadFile(fileService.announcement, file),

  /** Profile fotoğrafı için upload */
  uploadProfilePhoto: (file: File): Promise<string> =>
    fileService.uploadFile(fileService.profilePhoto, file),
};

export default fileService;
